(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('.parcel-calculator')) {
            return;
        }

        document.querySelector('.parcel-calculator > form').addEventListener('submit', (e) => {
            e.preventDefault();

            // Pre-Set Values
            let heightField = document.querySelector('#parcel-calculator-parcel-height');
            let widthField = document.querySelector('#parcel-calculator-parcel-width');
            let lengthField = document.querySelector('#parcel-calculator-parcel-length');
            let sizeField = document.querySelector('#parcel-calculator-parcel-size');
            let utmCampaignField = document.querySelector('#parcel-calculator-utm-campaign');
            let height = parseInt(heightField.value);
            let width = parseInt(widthField.value);
            let length = parseInt(lengthField.value);

            // Not all inputs are populated, only submit size
            if (!height || !width || !length) {
                sizeField.value = '';

                if(utmCampaignField) {
                    utmCampaignField.value = 'button'
                }

                e.currentTarget.submit()

                return false;
            }

            let longest = null;
            let shortest = null;

            let dimensions = [height, width, length];

            let i;

            for (i = 0; i < dimensions.length; i++) {
                if (longest === null || longest < dimensions[i]) {
                    longest = dimensions[i];
                }

                if (shortest === null || shortest > dimensions[i]) {
                    shortest = dimensions[i];
                }
            }

            let sizes = ['XS', 'S', 'M', 'L', 'XL'];
            let maxSize = 0;
            let matchSize = false;

            for (i = 0; i < sizes.length; i++) {
                maxSize = parseInt(document.querySelector('*[data-parcelsize="' + sizes[i] +'"]').getAttribute('data-maxlength'));

                if (maxSize > (shortest + longest)) {
                    matchSize = sizes[i];

                    break;
                }
            }

            if (matchSize === false) {
                matchSize = 'XL'
            }

            sizeField.value = matchSize

            if (utmCampaignField) {
                utmCampaignField.value = 'button'
            }

            e.currentTarget.submit()
        })

        document.querySelectorAll('.parcel-calculator button[data-parcelsize]').forEach((button) => {
            button.addEventListener('click', () => {
                // Set Variables from clicked values
                let clickedSize = button.getAttribute('data-parcelsize');
                let clickedMaxLength = parseInt(button.getAttribute('data-maxlength'));

                // Pre-Set Values
                let heightField = document.querySelector('#parcel-calculator-parcel-height');
                let widthField = document.querySelector('#parcel-calculator-parcel-width');
                let lengthField = document.querySelector('#parcel-calculator-parcel-length');
                let utmCampaignField = document.querySelector('#parcel-calculator-utm-campaign');
                let sizeField = document.querySelector('#parcel-calculator-parcel-size');
                let height = parseInt(heightField.value);
                let width = parseInt(widthField.value);
                let length = parseInt(lengthField.value);

                // Not all inputs are populated, only submit size
                if (!height || !width || !length) {
                    heightField.value = ''
                    widthField.value = ''
                    lengthField.value = ''
                }

                var longest = null;
                var shortest = null;

                var dimensions = [height, width, length];

                var i;

                for (i = 0; i < dimensions.length; i++) {
                    if (longest === null || longest < dimensions[i]) {
                        longest = dimensions[i];
                    }

                    if (shortest === null || shortest > dimensions[i]) {
                        shortest = dimensions[i];
                    }
                }

                if (longest + shortest > clickedMaxLength) {
                    heightField.value = ''
                    widthField.value = ''
                    lengthField.value = ''
                }

                sizeField.value = clickedSize;

                if(utmCampaignField) {
                    utmCampaignField.value = 'kachel' + clickedSize
                }

                var sizes = ['XS', 'S', 'M', 'L', 'XL'];
                var maxSize = 0;
                var matchSize = false;

                for (i = 0; i < sizes.length; i++) {
                    maxSize = parseInt(document.querySelector('*[data-parcelsize="' + sizes[i] +'"]').getAttribute('data-maxlength'));

                    if (maxSize > (shortest + longest)) {
                        matchSize = sizes[i];

                        break;
                    }
                }

                if (matchSize !== clickedSize) {
                    heightField.value = ''
                    widthField.value = ''
                    lengthField.value = ''
                }

                document.querySelector('.parcel-calculator > form').submit();
            })
        })
    })
}) ()
